import { useEffect, useState } from "react";

/**
 * Mapping des realms vers les informations des pays
 */
const realmToCountry: { [key: string]: { name: string; flag: string } } = {
  "be": { name: "Belgium", flag: "🇧🇪" },
  "ro": { name: "Romania", flag: "🇷🇴" },
  "pl": { name: "Poland", flag: "🇵🇱" },
  "lu": { name: "Luxembourg", flag: "🇱🇺" }
};

/**
 * DynamicTitle: Gère le titre dynamique avec drapeau selon le realm
 * Met à jour le titre de la page avec "Easy Tech {drapeau pays}"
 */
export default function DynamicTitle() {
  const [realm, setRealm] = useState<string | null>(null);

  useEffect(() => {
    // Récupérer le realm depuis le localStorage
    const currentRealm = localStorage.getItem("realm");
    setRealm(currentRealm);

    const handleStorageChange = () => {
      const newRealm = localStorage.getItem("realm");
      setRealm(newRealm);
    };

    window.addEventListener("storage", handleStorageChange);
    
    // Écouter les changements du realm dans la même fenêtre
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key, value) {
      if (key === "realm") {
        setRealm(value);
      }
      return originalSetItem.apply(this, [key, value]);
    };

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  useEffect(() => {
    if (realm && realmToCountry[realm]) {
      // Mettre à jour le titre de la page avec le nom du pays et le drapeau
      const countryInfo = realmToCountry[realm];
      document.title = `Easy Tech ${countryInfo.flag} ${countryInfo.name} `;
    } else {
      // Titre par défaut si pas de realm ou realm inconnu
      document.title = "Easy Tech";
    }
  }, [realm]);

  // Ce composant ne rend rien visuellement, il gère seulement le titre
  return null;
} 